import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "outputLazy"
  ];
  static values = { url: String };

  connect() {
    const token = new URLSearchParams(window.location.search).get("auth_token")

    const headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'text/html'
    }

    if (token) {
      headers['Authorization'] = `Bearer ${token}`
    }
    fetch(this.urlValue, {
      headers: headers,
      credentials: 'same-origin'
    })
      .then(response => response.text())
      .then(html => {
        this.outputLazyTarget.innerHTML = html
      })
      .catch(error => {
        console.error("[lazy-load] Erreur AJAX :", error)
      })
  }

  fetchContent(request) {
    fetch(request)
      .then((response) => {
        if (response.status === 200) {
          response.text().then((text) => (this.renderContent(text)));
        } else {
          this.renderContent(this.errorElement());
        }
      })
      .catch((error) => {
        this.renderContent(this.errorElement());
      });
  }

  renderContent(content) {
    this.outputLazyTarget.innerHTML = content
    this.dispatchEvent("lazy_load:complete")
  }

  dispatchEvent(eventName) {
    const event = new Event(eventName);
    document.dispatchEvent(event);
  }

  errorElement() {
    return `
      <div class="text-sm italic">
        Chargement impossible...
      </div>
    `
  }

}
